module.exports = __webpack_public_path__ + "img/good.1d70a65b.png";